// ─── Shared image placeholders ────────────────────────────────────────────────
// Centralised CDN paths for placeholder/skeleton images used when real content
// hasn't loaded yet. These are NOT page-specific; any section can import them.

import {cdnImage, cdnUrl} from '@/util/cdnImage';

/** Generic skeleton/shimmer placeholder for blog and content-card imagery. */
export const SKELETON_IMAGE = cdnImage('blog/skelton.webp');

/**
 * Office country flags (top bar, office addresses). Served straight from CloudFront and rendered
 * `unoptimized`: they are 1–2 KB, so the /_next/image optimizer adds nothing, and loading them
 * from the CDN keeps them independent of the web server's own static files.
 */
export const COUNTRY_FLAGS = {
    usa: cdnUrl('app-bar/usa.webp'),
    uk: cdnUrl('app-bar/uk.webp'),
    canada: cdnUrl('app-bar/Canada.webp'),
    india: cdnUrl('app-bar/india.webp')
} as const;
